export const normalizeEmail = (value) => {
  return (value || '').trim().toLowerCase()
}

export const normalizeName = (value) => {
  return (value || '')
    .toUpperCase()
    .replace(/[^A-ZÁÉÍÓÚÜÑ\s]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/, '')
}
